<template>
  <div class="col-lg-9 c-content-main">
    <div class="tile">
      <h3 class="tile-title is-line">{{ $t('email') }}</h3>
      <email-sender v-if="$store.state.user.permissions.includes('marketingEmailSetup')"></email-sender>
      <hr v-if="$store.state.user.permissions.includes('marketingEmailSetup')">
      <user-email></user-email>
    </div>
  </div>
</template>

<script>
  import UserEmail from "@/views/setting/communication/email/UserEmail";
  import EmailSender from "@/views/setting/communication/email/EmailSender";

  export default {
    name: "Email",
    components: {UserEmail, EmailSender}
  }
</script>